import {
  Input,
  Label,
  InputGroup,
  Button,
} from "reactstrap";
import _ from "lodash";
import { ui_helpers } from "../../helpers";
import classnames from 'classnames';
import { constants, storage } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from 'react-select'
import { default as useContractStore } from "./utils/useContractStore";

const SalespersonEdit = ({ onDeleteSalesperson }) => {
  const salesperson = useContractStore(x => x.salesperson);
  const setSalesperson = useContractStore(x => x.setSalesperson);
  const otherSalesperson = useContractStore(x => x.otherSalesperson);
  const salespeople = useContractStore(x => x.salespeople);
  const screenWarnings = useContractStore(x => x.screenWarnings);
  const setOtherSalesperson = useContractStore(x => x.setOtherSalesperson);

  return (
    <div className="mb-2" style={{ clear: "both" }}>
      <div>
        <Label>Salesperson {ui_helpers.requiredStar()}</Label>
      </div>
      <InputGroup size="sm">
        <div
          style={{ width: "70%" }}
          title={screenWarnings && screenWarnings.salesperson ? screenWarnings.salesperson : null}>
          <Select
            isDisabled={!salespeople}
            options={salespeople ? salespeople : constants.OTHER_OPTION}
            value={salesperson ? _.find(salespeople, (s) => s.label === salesperson.label) : null}
            classNamePrefix={screenWarnings && screenWarnings.salesperson ? "invalidSelect" : null}
            onChange={(s) => {
              if (s) {
                storage.setItem(constants.STORAGE_KEYS.LAST_SALESPERSON_LABEL, s.label);
              }
              setSalesperson(s);
            }}
          />
        </div>
        {salesperson && salesperson.label !== constants.OTHER ? (
          <Button
            color="danger"
            className="text-light"
            style={{ zIndex: 0 }}
            onClick={onDeleteSalesperson}>
            <FontAwesomeIcon icon="times-circle" />
          </Button>
        ) : null}
      </InputGroup>
      {salesperson && salesperson.label === constants.OTHER ? (
        <div className="control-group pt-1">
          <Input
            type="text"
            size="sm"
            maxLength="150"
            placeholder="Other Details"
            title={
              screenWarnings && screenWarnings.otherSalesperson
                ? screenWarnings.otherSalesperson
                : null
            }
            className={classnames({
              invalid: screenWarnings && screenWarnings.otherSalesperson ? true : false,
            })}
            value={otherSalesperson}
            onChange={(e) => setOtherSalesperson(e.target.value)}
          />
        </div>
      ) : null}
    </div>
  );
}
export default SalespersonEdit;
